export interface SearchTemplateItem {
  template_id: string;
  subject: string;
  name: string;
  used_in: string;
  status: SearchTemplateItemStatus;
  delivery_type: string;
  body: string;
  body_json: string;
  language: string;
  from_address: string;
  reply_to: string;
  bcc: string;
  fields_matched: string[];
  created_at: number;
  updated_at: number;
  action_id?: string;
  campaign_id?: string;
  newsletter_id?: string;
  transactional_message_id?: string;
}

export enum SearchTemplateItemStatus {
  Active = 'Active',
  Automatic = 'Sends automatically',
  Draft = 'Queues draft',
  Drafted = 'Drafted',
  Off = 'Will not send',
  Sent = 'Sent',
}
